"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeSchema = void 0;
exports.IkeSchema = {
    CALIBRATION: 'calibration',
    CALIBRATION_POST: 'calibration.post',
    CAPTURE: 'capture',
    CAPTURE_POST: 'capture.post',
    COLLECTION: 'collection',
    EVENT_GET: 'event.get',
    EVENT_POST: 'event.post',
    EVENT_POST_ARRAY: 'event.post.array',
    FORM: 'form',
    JOB: 'job',
};
//# sourceMappingURL=json.validator.js.map